"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 8.368a1.4 1.4 0 0 1-1.188-.665c-.39-.632-.918-1.286-1.525-1.768-.606-.481-1.208-.729-1.787-.729-.983 0-1.707.352-2.205.927C4.78 6.73 4.4 7.696 4.4 9.088c0 .754.286 1.645.86 2.647.568.99 1.365 1.997 2.256 2.953 1.626 1.745 3.46 3.213 4.492 3.99 1.03-.77 2.86-2.224 4.482-3.961.889-.953 1.684-1.958 2.25-2.951.572-1.003.86-1.905.86-2.678 0-1.612-.397-2.542-.87-3.061-.456-.5-1.163-.815-2.232-.82-.56-.004-1.157.24-1.768.726-.61.486-1.145 1.144-1.538 1.776a1.4 1.4 0 0 1-1.192.66Zm-.88-2.602c.343.392.64.806.884 1.202.245-.394.544-.807.888-1.2.926-1.058 2.18-1.97 3.614-1.962C19.204 3.82 21 5.44 21 9.088c0 4.422-6.484 9.493-8.443 10.924a.927.927 0 0 1-1.105-.002C9.495 18.566 3 13.448 3 9.088 3 5.81 4.796 3.806 7.5 3.806c1.446 0 2.699.904 3.62 1.96Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HeartIcon24.js.map